<template>
  <div class="flex flex-col items-start gap-3 self-stretch">
    <div class="flex flex-col items-start justify-between self-stretch">
      <div class="flex space-x-3">
        <span class="switch-handle mb-1 block text-sm font-medium text-gray-700">{{
          t("common.label")
        }}</span>
      </div>
      <UIInput
        id="label"
        v-model="updatePaymentLabel"
        size="medium"
        @update:model-value="store.anyUnsavedChanges = true"
        @blur="store.addToHistory()"
      />
    </div>
    <LabelAlignment
      :is-element-level="true"
      :label-alignment="getLabelAlignment"
      @update:label-alignment="handleLabelAlignment"
    ></LabelAlignment>
    <div
      v-if="store.payment.paymentType === 'donation'"
      class="flex flex-col items-start justify-between self-stretch"
    >
      <div class="flex space-x-3">
        <span class="switch-handle mb-1 block text-sm font-medium text-gray-700">{{
          t("common.shortLabel")
        }}</span>
      </div>
      <UIInput
        id="shortLabel"
        v-model="updatePaymentShortLabel"
        size="medium"
        class="standard-input-ghl"
        @update:model-value="store.anyUnsavedChanges = true"
        @blur="store.addToHistory()"
      ></UIInput>
    </div>
  </div>
  <UICheckbox
    id="required"
    :checked="store.payment.required"
    @update:checked="onRequiredChange"
    @blur="store.addToHistory()"
    >{{ t("common.required") }}</UICheckbox
  >
</template>

<script setup lang="ts">
import { useAppStore } from "@/store/app";
import { AlignmentPosition } from "@/util/methods";
import { UICheckbox, UIInput } from "@gohighlevel/ghl-ui";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import LabelAlignment from "../Elements/LabelAlignment.vue";

const { t } = useI18n();
const store = useAppStore();

const props = defineProps({
  selectedIndex: {
    type: Number,
    required: true,
  },
  selectedSlideIndex: {
    type: Number,
    required: false,
    default: undefined,
  },
});

const onRequiredChange = (isRequired: boolean) => {
  store.payment.required = isRequired;
  if (props.selectedSlideIndex !== undefined) {
    store.slides[props.selectedSlideIndex].slideData[props.selectedIndex].required = isRequired;
  } else {
    store.elements[props.selectedIndex].required = isRequired;
  }
  store.anyUnsavedChanges = true;
};
const updatePaymentLabel = computed({
  get() {
    return props.selectedSlideIndex !== undefined
      ? store.slides[props.selectedSlideIndex].slideData[props.selectedIndex].label
      : store.elements[props.selectedIndex].label;
  },
  set(value: string) {
    if (props.selectedSlideIndex !== undefined) {
      store.slides[props.selectedSlideIndex].slideData[props.selectedIndex].label = value;
    } else {
      store.elements[props.selectedIndex].label = value;
    }
    store.anyUnsavedChanges = true;
  },
});
const updatePaymentShortLabel = computed({
  get() {
    return props.selectedSlideIndex !== undefined
      ? store.slides[props.selectedSlideIndex].slideData[props.selectedIndex].shortLabel
      : store.elements[props.selectedIndex].shortLabel;
  },
  set(value: string) {
    if (props.selectedSlideIndex !== undefined) {
      store.slides[props.selectedSlideIndex].slideData[props.selectedIndex].shortLabel = value;
    } else {
      store.elements[props.selectedIndex].shortLabel = value;
    }
    store.anyUnsavedChanges = true;
  },
});

const getLabelAlignment = computed(() => {
  return props.selectedSlideIndex !== undefined
    ? store.slides[props.selectedSlideIndex].slideData[props.selectedIndex].labelAlignment
    : store.elements[props.selectedIndex].labelAlignment;
});

const handleLabelAlignment = (value: AlignmentPosition) => {
  if (props.selectedSlideIndex !== undefined) {
    store.slides[props.selectedSlideIndex].slideData[props.selectedIndex].labelAlignment = value;
  } else {
    store.elements[props.selectedIndex].labelAlignment = value;
  }
  store.anyUnsavedChanges = true;
};
</script>
